import class1Img from '../assets/images/class_image_1_edited.png';
import class2Img from '../assets/images/class_image_2_edited.png';




// [path to the image]: [image alt]
export const ImageIndex: Record<string, string> = {
    [class1Img]: 'A VATTP course in session.',
    [class2Img]: 'A VATTP course in session.',
    'https://images.unsplash.com/photo-1603331651359-86dd9d0a92c2?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dmVybW9udHxlbnwwfHwwfHx8Mg%3D%3D': 
        'A Vermont hill covered in fall foliage.',
    'https://images.unsplash.com/photo-1603559934483-aeb4d9fa45a3?q=80&w=2304&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D':
        'A Vermont town seen from a birdseye view.'
}